import Content from "@/components/common/Layout/Content"
import { Layout } from "antd"
import { FC } from "react"
import BookingLayoutHeader from "./BookingLayoutHeader"

const BookingLayout: FC<any> = ({ children }) => {
  return (
    <Layout className="layout-booking">
      <BookingLayoutHeader />
      <Content className="layout-booking__content">
        {children}
      </Content>
    </Layout>
  )
}

BookingLayout.displayName = 'BookingLayout'

export default BookingLayout